import axios from "axios";
import {ENDPOINTS} from "../../js/api/_config";

export class FeedbackServices {
    static getFeedback(feedBackID) {
        return axios({
            method: 'GET',
            url: ENDPOINTS.FEEDBACK.GET_FEEDBACK_DATA + feedBackID,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }

    static submitFeedBackData(data, feedBackID) {
        return axios({
            method: 'POST',
            url: ENDPOINTS.FEEDBACK.GET_FEEDBACK_DATA + "/complete",
            data: data,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }
}
